import { jwtDecode } from "jwt-decode";

export const isTokenValid = (token) => {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000; // Convert to seconds

    // Returns true if current time is BEFORE the expiration time
    return decoded.exp > currentTime;
  } catch (error) {
    return false; // Invalid token format
  }
};
